import { ConsultationsTable } from "pages/patient/PatientConsultationsPage/components/ConsultationsTable/ConsultationsTable";

import s from "./ConsultationNotesReviewPanel.module.css";

// Consultation-notes review for a CDM/PP/OCF review — reuses the existing patient
// consultations table (each entry shows its consultation notes). Presentation-
// agnostic: render it inside an Accordion, a Modal, or anywhere a patientId is known.
export const ConsultationNotesReviewPanel = ({ patientId }) => (
  <div className={s.panel} data-testid="consultation-notes-review-panel">
    <ConsultationsTable patientIdVal={patientId} itemsPerPage={10} />
  </div>
);
